import { axiosApiService } from "./axios";

const EquipmentListAPIs = {
  FilterEquipmentListGet: async function({ accessToken, page = 1, search = '', page_size = 12 }) {
    try {
      const response = await axiosApiService.get(`/admin_equipment_list/`, {
        params: {
          page,
          search,
          page_size
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching Equipment list:', error);
      throw error;
    }
  },
};

export default EquipmentListAPIs;